import type { SvgComponent } from '@/types/SvgComponent';

/**
 * `.icon.modifier.minus.large` from the Weave DS migration file — an 11px box holding a 5px mark
 * with a 1px stroke, as the "Runs counter" design specifies for the stepper controls.
 *
 * `@figma/fpl-icons` ships no bare equivalent: `IconModifierRemoveLarge` is the same 11px box but
 * adds a filled status badge locked to `--color-icon-danger`, and `Icon24MinusLarge` draws an 11px
 * mark — over twice the designed size. The fill resolves through the enclosing FPL control, so a
 * disabled `IconButton` dims the glyph without this component knowing about state.
 */
export const ModifierMinusLargeIcon: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        d="M7.5 5C7.77614 5 8 5.22386 8 5.5C8 5.77614 7.77614 6 7.5 6H3.5C3.22386 6 3 5.77614 3 5.5C3 5.22386 3.22386 5 3.5 5H7.5Z"
        fill="var(--fpl-icon-color, var(--color-icon))"
      />
    </svg>
  );
};
